/**
 * TableCol  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo } from "react";
import { getBaseClass } from "./baseClass";
import { TableCellAlign } from "./TableTypes";
import { useTableContext } from "./TableContext";

export interface ITableColProps extends React.ComponentPropsWithoutRef<"td"> {
	align?: TableCellAlign;
}

export const TableCol: React.FC<ITableColProps> = ({ children, align, className, ...props }) => {
	const { headerHeight } = useTableContext();

	const baseClass = getBaseClass("cell", { align });

	const style = useMemo(() => (isFinite(headerHeight) ? { top: headerHeight + 2 } : {}), [ headerHeight ]);

	if (className) {
		baseClass.add(className);
	}

	return (
		<td className={baseClass.toClassName()} style={style} {...props}>
			<div className={baseClass.element("cell-content").toClassName()}>{children}</div>
		</td>
	);
};
